import MenuComponent from "../component/MenueComponent";
import { MyFooter } from "../landingpage/MyFooter";

export function Impressum() {

  return (
    <>

      {/*<MyHeader />*/}

      <div className="container">

        <div className="content row">

          <MenuComponent aktuelleseite="impressum" />

          <h2 style={{ textAlign: "center", width: "100%" }}>Impressum</h2>

          <h4 style={{ textAlign: "center", width: "100%" }}>volkslauf-neermoor.de</h4>

          <p>

            Anschrift und Kontaktdaten
            <br />
            SV Concordia Neermoor e.V.
            <br />
            Wilhelmstrasse 2b
            <br />
            26802 Moormerland
            <br />
            Telefon: 04954 3051873
            <br />
            E-Mail: info[at]volkslauf-neermoor.de
            <br />
            Internet: www.concordia-neermoor.de
            <br />
            <br />
            Vertretungsberechtigter Vorstand
            <br />
            Erster Vorsitzender: Norbert Sowa
            <br />
            Zweiter Vorsitzender: Jens Grafenburg
            <br />
            Registergericht: Amtsgericht Aurich
            <br />
            Registernummer: VR 110006
            <br />
            Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umstatzsteuergesetz
            <br />
            DE XXX
            <br />
            Verantwortlich im Sinne des § 5 TMG:
            <br />
            Verantwortlich für Text & Design
            <br />
            SV Concordia Neermoor e.V.

          </p>
          <p>
            Auf dieser Domaine verwenden wird die Bibliotheken jQuery und Bootstrap. Unsere Webseite verwendet keine Cookies.
          </p>
        </div>
      </div>

      <MyFooter />
    </>
  );
}

export default Impressum;